import React from 'react';
import { PaletteIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function FinalCTASection() {
  return <section className="bg-brand-blue px-4 py-24 text-center text-white" data-id="element-72" data-mp="3n4wducxaczp9">
      <Reveal className="mx-auto max-w-3xl" data-id="element-73" data-mp="3s2xtsozf0iwi">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-white/15 text-brand-ochre" data-id="element-74" data-mp="vlekfi3efj8">
          <PaletteIcon className="h-7 w-7" aria-hidden="true" data-id="element-75" data-mp="2zea66mr71hfs" />
        </div>
        <h2 className="mt-5 text-4xl font-extrabold md:text-5xl" data-id="element-76" data-mp="34cbw9rn1eh0r">Pronto/a a Portare l&apos;Arte in Ogni Classe?</h2>
        <p className="mx-auto mt-5 max-w-xl leading-relaxed text-white/80" data-id="element-77" data-mp="39beqsi5e54uh">
          Unisciti agli insegnanti che stanno già trasformando le loro lezioni di arte con ARTE PRONTA™.
        </p>
        <CTAButton className="mt-9 px-8 py-5 text-base md:text-lg" data-id="element-78" data-mp="2gniv9grk5iza">OTTIENI ARTE PRONTA™ ORA</CTAButton>
        <p className="mt-4 text-xs font-semibold text-white/75" data-id="element-79" data-mp="2llapwijl7j76">
          Accesso immediato · Pronto da stampare · Garanzia 30 giorni
        </p>
      </Reveal>
    </section>;
}